const baseTemplate = {
  subscription_item: 'The ID of the subscription item for this usage record::String',
  quantity: 'Number',
  timestamp: 'Number',
}

export default baseTemplate
